import { baseApi } from "../app/api";
import { store } from "../app/store";
import i18n from "../app/i18n";
import { hydrateComponents } from "../app/hydrate";

export const app = {
  // Expose the base RTK Query API so themes can inject custom endpoints
  api: {
    baseApi,
  },

  // Expose the store so themes can inject new reducers via store.injectReducer
  // or access state directly outside of React components
  store,

  // Expose the i18n instance in case the theme needs to load extra translations dynamically
  i18n,

  // Expose the hydrator in case the theme manipulates the DOM and needs to re-hydrate React components manually
  hydrateComponents,
};
